export abstract class RouteNames {
    // Base routes
    public static readonly pageNotFound: string = '**';
    public static readonly root: string = '';
    public static readonly portal: string = 'portal';
    public static readonly overview: string = 'overview';
    public static readonly roster: string = 'roster';
    public static readonly oite: string = 'oite';
    public static readonly rock: string = 'rock';
    public static readonly orderSummary: string = 'orderSummary';
  public static readonly unauthorized: string = 'unauthorized';
  public static readonly admin: string = 'admin';
  public static readonly faculty: string = 'faculty';
    // Custom routes
    public static readonly Prototype: string = 'prototype';
    public static readonly Login: string = 'login';
}


